<!--suppress HtmlUnknownTag -->
<template>
  <div v-if="speeches.length">
    <b-nav-item-dropdown id="speechPicker" :html="currentSpeechData">
      <b-dropdown-item v-for="(speech, i) in speeches" :key="i">
        <b-dropdown-item-button @click="setSpeech(speech.key)">
          {{ speech.value }}
        </b-dropdown-item-button>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import * as actions from '../../store/action-types'

export default {
  name: 'SpeechPicker',
  components: {},
  data() {
    return {
      speeches: [
        { key: 'google', value: 'Google Speech' },
        { key: 'deep', value: 'Deep' }
      ],
      currentSpeech: localStorage.getItem('speech')
        ? localStorage.getItem('speech')
        : this.$store.state.speech
    }
  },
  computed: {
    // eslint-disable-next-line vue/no-dupe-keys
    currentSpeechData: function() {
      let element = this.speeches.find(element => {
        return element.key === this.currentSpeech
      })
      return element.value
    }
  },
  methods: {
    setSpeech(speech) {
      this.currentSpeech = speech
      this.$store.dispatch(actions.SET_SPEECH, speech)
      if (navigator.cookieEnabled) {
        localStorage.setItem('speech', speech)
      }
    }
  }
}
</script>

<style lang="scss">
.nav-link-dropdown {
  background-color: transparent;
}
#speechPicker {
  z-index: 1030;
}
.dropdown-menu {
  min-width: 0 !important;
}
.dropdown-item {
  padding: 0.2rem 0.5rem !important;
}
</style>
